<section class="app-blik">
  <h2
    [appAnimate]="'landing'"
    [speed]="'fast'"
    [aos]="0.2"
    [once]="true"
    [delay]="'100'"
    class="app-blik--h2 app-title text-center navy-blue"
  >
    Jak korzystać z Czeków BLIK?
  </h2>

  <div class="container app-blik__con">
    <ul class="list-unstyled app-blik__con__ul">
      <li
        class="app-blik__con__ul__li"
        [appAnimate]="'bounceInRight'"
        [aos]="0.2"
        [once]="true"
        [speed]="'slow'"
        [delay]="'100'"
      >
        <figure class="m-0 app-blik__con__ul__li__fi">
          <img
            ngSrc="assets/images/blik/step-1.webp"
            alt="first"
            width="273"
            height="273"
            priority="false"
            class="app-blik__con__ul__li__fi--img"
          />
          <figcaption class="app-blik__con__ul__li__fi__fig">
            <p class="app-blik__con__ul__li__fi__fig--p">
              W&nbsp;bankomacie wybierz opcję
              <b>wypłata <br class="d-none d-lg-block" />bez karty</b> lub
              <b>wypłata BLIK</b>, a&nbsp;następnie
              <br class="d-none d-lg-block" />wybierz kwotę wypłaty. Kwota
              wypłaty musi <br class="d-none d-lg-block" />być równoważna
              z&nbsp;wysokością nagrody, <br class="d-none d-lg-block" />czyli
              1000, 500, 200 lub 100&nbsp;zł.
            </p>
          </figcaption>
        </figure>
      </li>
      <li
        class="app-blik__con__ul__li"
        [appAnimate]="'bounceInRight'"
        [aos]="0.2"
        [once]="true"
        [speed]="'slow'"
        [delay]="'300'"
      >
        <figure class="m-0 app-blik__con__ul__li__fi">
          <img
            ngSrc="assets/images/blik/step-2.webp"
            alt="second"
            width="273"
            height="273"
            priority="false"
            class="app-blik__con__ul__li__fi--img"
          />
          <figcaption class="app-blik__con__ul__li__fi__fig">
            <p class="app-blik__con__ul__li__fi__fig--p">
              Wpisz <b>9-cyfrowy numer Czeku BLIK</b>,
              <br class="d-none d-lg-block" />który znajdziesz w&nbsp;przesłanej
              wiadomości <br class="d-none d-lg-block" />mailowej.
            </p>
          </figcaption>
        </figure>
      </li>
      <li
        class="app-blik__con__ul__li"
        [appAnimate]="'bounceInRight'"
        [aos]="0.2"
        [once]="true"
        [speed]="'slow'"
        [delay]="'500'"
      >
        <figure class="m-0 app-blik__con__ul__li__fi">
          <img
            ngSrc="assets/images/blik/step-3.webp"
            alt="third"
            width="273"
            height="273"
            priority="false"
            class="app-blik__con__ul__li__fi--img"
          />
          <figcaption class="app-blik__con__ul__li__fi__fig">
            <p class="app-blik__con__ul__li__fi__fig--p">
              <b>Potwierdź transakcję kodem PIN</b>,
              <br class="d-none d-lg-block" />
              który otrzymałeś/-aś w&nbsp;wiadomości SMS. Gotowe!
            </p>
          </figcaption>
        </figure>
      </li>
    </ul>
  </div>

  <p
    class="app-blik--p text-center"
    [appAnimate]="'landing'"
    [speed]="'fast'"
    [aos]="0.2"
    [once]="true"
    [delay]="'100'"
  >
    <span>
      <b>Lista banków, w których można wykorzystać Czeki BLIK:</b>
      <br class="d-none d-lg-block" />
      Santander Bank, PKO BP, Millenium, BNP Paribas, mBank, ING, BPS (Bank
      Polskiej Spółdzielczości), SGB (Spółdzielcza Grupa
      <br class="d-none d-lg-block" />Bankowa), sieć Planet Cash.
    </span>
  </p>
</section>
